import React from "react";
import HeroIcon from "components/HeroIcon";
import Body from "components/Body";

export default function NodePublicationTeaser({ node }) {
  const [name, extension] = node.field_file.filename.split(".");
  const body = node.body || node.field_body;
  let icon = "document";
  const iconForTypes = {
    "document-text": ["doc", "odf", "odt", "docx"],
    "document-report": ["ods", "xls", "xlsx"],
    photograph: ["png", "gif", "jpg", "jpeg", "odt"],
    archive: ["tar", "gz", "zip"],
    document: ["pdf"],
  };

  Object.keys(iconForTypes).forEach((iconName) => {
    if (iconForTypes[iconName].includes(extension)) {
      icon = iconName;
    }
  });

  function handleClick() {
    document.getElementById(node.id).click();
  }

  return (
    <div
      className="flex flex-col group md:flex-row items-center justify-between w-10/12 mx-auto py-8 border-b-2 last:border-b-0 border-primary-lighter cursor-pointer"
      onClick={() => {
        handleClick();
      }}
    >
      <div className="md:w-1/12 w-full md:mr-12">
        <HeroIcon name={icon} className="text-secondary md:mr-2 h-20" />
      </div>
      <div className="col-span-2 w-full md:w-11/12 relative">
        <h3 className="text-2xl bold mb-4 font-semibold group-hover:text-secondary ">
          {node.title}
        </h3>
        <div>
          <Body value={body.value} />
        </div>
        <a
          id={node.id}
          className="sr-only"
          href={`${process.env.NEXT_PUBLIC_DRUPAL_RUNTIME_BASE_URL}${node.field_file.uri.url}`}
          target="_blank"
          rel="noreferrer"
          download
          title={`Télécharger "${name}"`}
        >
          Télécharger
        </a>
      </div>
    </div>
  );
}
